import { Stack } from '@mui/material';
import { FormBaseLayout } from 'modules/components/layer10';
import { SelectPlanField } from 'modules/components/layer04';
import React from 'react';
import * as ds from './dataService';
import _ from 'lodash';


export type SaveInstallationPlanFormProps = {
  id: string;
  projectId: string;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveInstallationPlanFormProps) => {
  const form = ds.useFormState(props.id, props.projectId);
  const [
    fnSaveInstallationPlan,
    { loading }
  ] = ds.useSaveInstall();

  const handleSubmit = async (input: ds.IFormState) => {
    const tempInput = _.mapValues(input, (node) => {
      if (node === '') {
        return undefined;
      }
      return node;
    });

    await fnSaveInstallationPlan(tempInput);
  };


  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await handleSubmit(form.formState);
        props.handleClose();
      }}
      isLoading={loading}
      cancelButtonText='Cancel'
      successButtonText='Save'
    >
      <Stack
        rowGap='1.5rem'
        width='28rem'
      >
        <SelectPlanField.FC
          form={form}
          fieldName='planId'
        />
      </Stack>
    </FormBaseLayout.FC>
  );
};
